<template>
    <div class="purchase-course vod">
        <template v-if="buttonOnly">
            <template v-if="vodCourse.isUserPreRegistered">
                <div class="text-white mt-1 pt-2">You have already registered your interest in this course.</div>
            </template>
            <template v-else>
                <b-button variant="primary" class="btn-slimpad btn-block btn-white btn-register-interest" @click="registerClick">Register interest</b-button>
            </template>
        </template>
        <template v-else>

            <template v-if="vodCourse.isUserPreRegistered">
                <div class="mt-3">
                    <h3 class="notif mb-0">You have already registered your interest in this course.</h3>
                </div>
            </template>
            <template v-else>

                <div class="row justify-content-center">
                    <div class="col-md-10">
                        <div class="block left">
                            <div class="row">
                                <div class="col-12 col-lg-8">
                                    <h3 class="mb-2 mt-0">
                                        Are you ready to learn?
                                    </h3>
                                    <ul class="list-unstyled">
                                        <li>Sign up to our mailing list and be notified when this course is available.</li>
                                    </ul>
                                </div>
                                <div class="col-12 col-lg-4 meta-col d-flex align-items-stretch">
                                    <div class="meta-info no-border">
                                        <b-button variant="primary" class="btn-slimpad btn-block btn-white" @click="registerClick">Register interest</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </template>

         <b-modal ref="registerModal" :title="'Pre-register for ' + vodCourse.name" :ok-only="true" ok-variant="link" ok-title="Close">
            <template v-if="isAuth">
                <template v-if="isSuccess">
                    Thanks! You have registered your interest in this course. We will be in touch when this course is going on sale.
                </template>
                <template v-else>
                    <template v-if="isBusy">
                        Please wait...
                    </template>
                    <template v-else>
                        <b-alert variant="danger" :show="hasError" class="mb-2">{{ error }}</b-alert>
                        <b-button variant="success" @click="beginPreReg">Register interest</b-button>
                    </template>
                </template>
            </template>
            <template v-else>
                <p>
                    You're one step from registering your interest.  We just need a name, email and password.
                    You'll use your free account with us to take part in the course.
                </p>
                <auth-basic-component :vodCourse="vodCourse"></auth-basic-component>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            vodCourse: {
                type: Object,
                required: true,
            },
            buttonOnly: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        data() {
            return {
                isAuth: false,
                user: {},
                isNewUser: false,
                isBusy: false,
                hasError: false,
                error: '',
                isSuccess: false,
            }
        },

        mounted() {
            // User logged in?
            if(window.virtuoso) {
                if(window.virtuoso.is_auth) {
                    this.isAuth = true;
                    this.user = window.virtuoso.user;
                }
            }

            // Pre registration has begun
            Bus.$on("vodPreRegisterBusy", (d) => {
                this.isBusy = true;
                this.hasError = false;
                this.error = '';
            });

            // Pre registration successful
            Bus.$on("vodPreRegisterSuccess", (d) => {
                this.isAuth = true;
                this.isSuccess = true;
            });

            // Pre registration failed
            Bus.$on("vodPreRegisterError", (d) => {
                this.hasError = true;
                this.error = d;
                this.isBusy = false;
            });
        },

        methods: {
            // Clicked to apply for a seat
            registerClick() {
                this.$refs['registerModal'].show('registerModal');

                // Fire it immediately to stop using having to click again
                if(this.isAuth) {
                    this.beginPreReg();
                }
            },

            // Fires an event picked up by the handler component
            beginPreReg() {
                Bus.$emit('fireVodPreRegister', this.user);
            },
        }
    }
</script>
